module.exports = __webpack_public_path__ + "static/media/add.9332f51d.svg";